<script>
    export let short = false;
    export let ajankohtaistaUrl = "2025-01-19-helmikuun-leirit";
    let title = "Helmikuun leirit!";
    let titlePic = "/svelte-site/img/ajankohtaista/taneli_nita.jpg";
    let firstPara = "Tanelin Painonnostoleiri 8.2. | Nitan kässärit haltuun -tyopaja 16.2. | Ilmoittaudu mukaan!";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                  style="background-image: url('{titlePic}"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>

{:else}
    <div class="blog page">
        <article class="container">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <h1>{title}</h1>
                    <h4>Painonnosto tutuksi - valmennus lauantaina 8.2. klo 14-17 !</h4>

                    <p>Tervetuloa 8.2.2025 klo 14-17 jo useamman kerran järjestettyyn ja paljon tykättyyn valmennukseen,
                        jossa käydään läpi painonnoston kilpailuliikkeiden (tempaus ja työntö) lisäksi taka- sekä
                        etukyykky ja paljon oheisharjoitteita. Valmennuksesta vastaa painonnoston moninkertainen
                        suomenmestari sekä kokenut painonnosto-, fysiikka- ja voimaharjoitteluvalmentaja Taneli Ollila.
                    </p>
                    <p>Mitä valmennus sisältää ja aikataulu:</p>

                    <ul>
                        <li>14.00 - 15.20 lämmittely, tempaus, rinnalleveto</li>
                        <li>15.20 - 15.40 evästauko ja Q&A</li>
                        <li>15.40 - 17.00 ylöstyöntö, kyykyt, apuliikkeet</li>
                        <li>17.00 - Q&A, vapaata keskustelua, vinkkejä</li>
                    </ul>
                    <b>Kenelle valmennus sopii?</b>
                    <p>
                        🫵 kenelle tahansa, joka on kiinnostunut painonnostosta ja/tai voimaharjoittelusta. Aikaisempaa
                        kokemusta kummastakaan ei tarvi! Olet sitte vasta-alkaja tai kokeneempi treenaaja, niin olet
                        tervetullut!</p>
                    <p>💰Valmennus maksaa 69 €</p>
                    <p>Valmennuksen voit maksaa asioidessasi Dynamosalilla. Maksutapoina toimii kortti, tavanomaiset
                        liikuntasetelit ja (asiakkaille) lasku. Maksu pitää olla maksettuna ennen leirin alkua.</p>
                    <p>Ilmoittauduthan viimeistään 5.2.2022 klo 24.00 mennessä.
                        <a href="https://forms.gle/G8fjHEX8jp12SDuH9">Ilmoittaudu tästä!</a></p>
                </div>
                <div class="col-xs-12 col-md-6">
                    <img src="/svelte-site/img/ajankohtaista/taneli.jpg"/>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <h4>Käsiseisonta & Liikkuvuus -työpajat Dynamosalilla 16.2.2025</h4>
                    <p>
                        Haluatko oppia käsilläseisonnan ilman aiempaa kokemusta tai löytää balanssia käsien päällä? Nita
                        Lehto tulee jälleen salillemme pitämään käsilläseisontatyöpajaa helmikuussa. Nyt on sinullakin
                        mahdollisuus saada harvinaislaatuista opetusta käsilläseisontaan ja liikkuvuusharjoitteluun
                        ammattitason valmentajalta.</p>
                    <p>
                        Kurssilla on 100% rahat takaisin takuu, jos koet, ettei workshop ollut rahojesi arvoinen.
                        Huhujen mukaan kaikki osaavat seisoa käsillään tämän jälkeen!
                    </p>
                    <ul>
                        <li>Käsiseisontatyöpaja klo 12.00-14.00 (49 €)</li>
                        <li>Liikkuvuustyöpaja. klo 14.15-15.15 (29 €)</li>
                        <li> Molemmat workshopit yhteishintaan vain 59 € !</li>
                    </ul>
                    <p>
                        Molemmat työpajat sisältävät myös treeniohjeet kotiin.
                        Ilmoittaudu mukaan / kysy lisää<br>
                        info@nitsku.fi </p>

                    <p>
                        Tsekkaa lisää: <a target="_blank" href="https://fb.me/e/47KHm4ESw">
                        https://fb.me/e/47KHm4ESw </a>
                    </p>

                    <p></p>


                    <br>
                    Leiriterveisin
                    <br>
                    Dynamon koutsit
                </div>
                <div class="col-xs-12 col-md-6">
                    <img src="/svelte-site/img/ajankohtaista/nita-kassarit.jpg"/>
                </div>
            </div>


        </article>
    </div>
{/if}
